import { computed, ref } from 'vue';
import { defineStore } from 'pinia';

/**
 * PQ-002 — every backend call must produce visible feedback.
 *
 * A counter rather than a boolean: with concurrent requests, a boolean is cleared by
 * whichever call finishes first, and the indicator disappears while work is still in
 * flight.
 */
export const useLoadingStore = defineStore('loading', () => {
  const inFlight = ref(0);

  const isLoading = computed(() => inFlight.value > 0);

  function start(): void {
    inFlight.value += 1;
  }

  function finish(): void {
    inFlight.value = Math.max(0, inFlight.value - 1);
  }

  return { inFlight, isLoading, start, finish };
});
